import isAbsoluteUrl from "@/utils/isAbsoluteUrl";

export default {
  methods: {
    getAssetUrl: function(path) {
      return isAbsoluteUrl(path)
        ? path
        : (process.env.VUE_APP_BASE_URL
            ? process.env.VUE_APP_BASE_URL
            : process.env.BASE_URL) + path;
    }
  }
};
